import React from "react";
import PropTypes from "prop-types";

import FaCheckCircle from "react-icons/lib/fa/check-circle";
import FaAsterisk from "react-icons/lib/fa/asterisk";
import FaSpinner from "react-icons/lib/fa/spinner";
import FaTimesCircle from "react-icons/lib/fa/times-circle";
import FaExclamation from "react-icons/lib/fa/exclamation-circle";
import FaInfoCircle from "react-icons/lib/fa/info-circle";

import "icon.css";
const light_blue = "#007dbb";
const dark_blue = "#00447c";
const red = "#d13239";
const gray = "#6b6c6b";
const green = "#449d44";

//As selected by Icon.props.type. If no classNames are needed, set classNames to [].
let iconProps = {
  tick: {
    classNames: [],
    color: green,
    Icon: FaCheckCircle
  },
  spinner: {
    classNames: ["fa-spin"],
    color: dark_blue,
    Icon: FaSpinner
  },
  exclamation: {
    classNames: [],
    color: red,
    Icon: FaExclamation
  },
  asterisk: {
    classNames: [],
    color: gray,
    Icon: FaAsterisk
  },
  cross: {
    classNames: [],
    color: red,
    Icon: FaTimesCircle
  },
  info: {
    classNames: [],
    color: light_blue,
    Icon: FaInfoCircle
  }
};

let sharedPropTypes = {
  size: PropTypes.oneOf(["large", "normal", "small"]),
  className: PropTypes.string
};

let sharedDefaultProps = {
  size: "normal"
};

function Icon(props = {}) {
  let OutputIcon = iconProps[props.type].Icon;
  let iconClassNames = [
    "upn-component-icon",
    `upn-component-icon--${props.size}`,
    ...iconProps[props.type].classNames
  ];
  if (props.className !== undefined) iconClassNames.push(props.className);
  return (
    <OutputIcon
      color={iconProps[props.type].color}
      className={iconClassNames.join(" ")}
    />
  );
}

//Icons props are 'type' and the props in sharedPropTypes. Each option of type.oneOf must match a property of iconProps.
Icon.propTypes = {
  ...sharedPropTypes,
  type: PropTypes.oneOf([
    "tick",
    "spinner",
    "exclamation",
    "asterisk",
    "cross",
    "info"
  ]).isRequired
};

Icon.defaultProps = sharedDefaultProps;

export { Icon };

function Tick(props = {}) {
  return <Icon size={props.size} className={props.className} type="tick" />;
}

Tick.propTypes = sharedPropTypes;
Tick.defaultProps = sharedDefaultProps;

export { Tick };

function Asterisk(props = {}) {
  return <Icon size={props.size} className={props.className} type="asterisk" />;
}

Asterisk.propTypes = sharedPropTypes;
Asterisk.defaultProps = sharedDefaultProps;

export { Asterisk };

function Spinner(props = {}) {
  return <Icon size={props.size} className={props.className} type="spinner" />;
}

Spinner.propTypes = sharedPropTypes;
Spinner.defaultProps = sharedDefaultProps;

export { Spinner };

function Cross(props = {}) {
  return <Icon size={props.size} className={props.className} type="cross" />;
}

Cross.propTypes = sharedPropTypes;
Cross.defaultProps = sharedDefaultProps;

export { Cross };

function Exclamation(props = {}) {
  return (
    <Icon size={props.size} className={props.className} type="exclamation" />
  );
}

Exclamation.propTypes = sharedPropTypes;
Exclamation.defaultProps = sharedDefaultProps;

export { Exclamation };
